export const DEVICE_ID_WEB = 'Web';
